import './ServiceAccountsTab.scss';

export { default } from './ServiceAccountsTab';
